var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11 5.97071L6.27223 10.6985C5.69304 11.2777 4.90749 11.603 4.0884 11.603C3.26931 11.603 2.48376 11.2777 1.90457 10.6985C1.32538 10.1193 1 9.33374 1 8.51465C1 7.69555 1.32538 6.91001 1.90457 6.33082L6.63234 1.60305C7.01847 1.21692 7.54216 1 8.08823 1C8.63429 1 9.15799 1.21692 9.54411 1.60305C9.93024 1.98917 10.1472 2.51287 10.1472 3.05893C10.1472 3.605 9.93024 4.12869 9.54411 4.51482L4.8112 9.24259C4.61814 9.43565 4.35629 9.54411 4.08326 9.54411C3.81022 9.54411 3.54838 9.43565 3.35531 9.24259C3.16225 9.04953 3.05379 8.78768 3.05379 8.51465C3.05379 8.24162 3.16225 7.97977 3.35531 7.7867L7.72297 3.42419",
    stroke: "#404859",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.3675c4d3832ee3f31adf3f3240036d06.svg";
export { ForwardRef as ReactComponent };